export default __webpack_public_path__ + "8f10e3e42f18c3db6cadfd217ba171e3.png";